import { FunctionComponent } from 'react';
import Button from '@material-ui/core/Button';
import { IAppProps } from '../../common/interface/IAppProvider';
import GridWrapper from '../../components/shared/grid-wrapper/GridWrapper';
import RenderHtml from '../../components/shared/render-html/RenderHtml';

const PageNotFoundScreenView: FunctionComponent<IAppProps> = (props): JSX.Element => {
    const common = props.config.resourceBundles['dk.onsa-common'].read();
    const cb_404 = props.config.contentBlocks['common/404'].read();

    return (
        <GridWrapper>
            <form
                noValidate={true}
                action={'https://www.topdanmark.dk/faa-hjaelp/kontakt-os/'}
                target={'_blank'}
                name={`onsa-travel-form-not-found`}
                id={`onsa-travel-form-not-found`}
            >
                <RenderHtml>{cb_404.data}</RenderHtml>

                <Button fullWidth variant="contained" type={'submit'}>
                    {common['button.contact']}
                </Button>
            </form>
        </GridWrapper>
    );
};

export default PageNotFoundScreenView;
